import { Alert, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { PageHeader } from "../../components/PageHeader";

export const DataHome = () => (
  <div className="wp-fade-in">
    <PageHeader
      title="Data"
      subtitle="Manage custom fields and metadata across your platform"
      showBreadcrumbs={false}
    />
    <Stack gap="md">
      <Text>
        The Data service lets you extend any entity in your platform with{" "}
        <Text fw={700} span>
          Custom Fields
        </Text>{" "}
        and{" "}
        <Text fw={700} span>
          Object Metadata
        </Text>
        .
      </Text>
      <Text>
        <Text fw={700} span>
          Custom Fields
        </Text>{" "}
        are structured, typed fields you define per object type (e.g.
        Tournament, Player, Event). They support validation, visibility
        controls, and editability rules. End users and API consumers can then
        set values for these fields on individual objects.
      </Text>
      <Text>
        <Text fw={700} span>
          Object Metadata
        </Text>{" "}
        is a flexible key-value store for attaching arbitrary data to any
        supported object. Each entry has a type (String, Boolean, URL, Image
        URL) and a visibility setting (Public or Private).
      </Text>
      <Alert icon={<IconInfoCircle />} color="indigo" variant="light">
        Custom fields and metadata can be managed through the console or
        programmatically via the GraphQL API. Use the embedded panels in entity
        detail screens (Tournaments, Events, Players, Leaderboards, Platforms,
        Venues, Shops, Webhooks, and more) to manage values per object.
      </Alert>
    </Stack>
  </div>
);
